<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="33%" :before-close="handleClose">
    <el-form ref="info" class="global-form2" :model="info" :rules="rules" label-position="right" label-width="110px">
      <el-form-item label="所属项目" prop="projectId">
        <el-select :disabled="isEdit" @change="selectProject" v-model="info.projectId" filterable placeholder="请选择所属项目">
          <el-option v-for="item in normalProjectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="mb20" label="加班日期" prop="overtimeDate">
        <el-date-picker :disabled="isEdit" v-model="info.overtimeDate" type="date" value-format="yyyy-MM-dd"
          :picker-options="pickerOptions" placeholder="请选择使用日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="overtimeType" label="工人/班组">
        <el-radio-group v-model="info.overtimeType" @input="selectOvertimeType">
          <el-radio label="1" :disabled="isEdit">自建工人</el-radio>
          <el-radio label="2" :disabled="isEdit">劳务班组</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-show="info.overtimeType === '1'" label="工人信息" prop="workers">
        <el-select @change="selectWorkers" v-model="info.workers" multiple filterable placeholder="请选择工人信息">
          <el-option v-for="item in userList" :key="item.workerId" :label="item.workerName"
            :value="item.workerId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-show="info.overtimeType === '2'" label="班组信息" prop="teamId">
        <el-select v-model="info.teamId" filterable placeholder="请选择班组信息">
          <el-option v-for="item in teamData" :key="item.teamId" :label="item.teamName"
            :value="item.teamId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="overtimeNum" label="加班人数">
        <el-input v-model.number="info.overtimeNum" :disabled="info.overtimeType === '1'" />
      </el-form-item>
      <el-form-item prop="overtimeHours" label="加班时长">
        <el-input v-model="info.overtimeHours" placeholder="请输入加班时长(h)" />
      </el-form-item>
      <el-form-item prop="laborPrice" label="加班单价">
        <el-input v-model="info.laborPrice" placeholder="请输入加班单价" /> 元/小时
      </el-form-item>
      <el-form-item prop="laborAmount" label="费用总额">
        <el-input v-model="info.laborAmount" placeholder="请输入费用总额" /> 元
      </el-form-item>
      <el-form-item prop="remark" label="加班说明">
        <el-input v-model="info.remark" placeholder="请输入加班说明" maxlength="1000" />
      </el-form-item>
      <el-form-item label="加班图片" prop="fileList">
        <div class="imgList">
          <div class="imgBlock" v-for="(item, index) in info.fileList" :key="index">
            <el-image :src="item.filePrefix + item.fileUrl" :preview-src-list="[item.filePrefix + item.fileUrl]"
              fit="fill">
            </el-image>
            <span></span>
            <i class="el-icon-close" @click="imgRemove(index)"></i>
          </div>
          <UploadFile :accept="'jpeg,jpg,png'" @onSuccess="onSuccess" :slotShow='true' v-if="info.fileList.length < 6">
            <i class="el-icon-plus"></i>
            <p>上传图片</p>
          </UploadFile>
        </div>
        <div class="mt20">(最多六张)</div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="saveForm" :disabled='submitShow'>保存</el-button>
        <el-button @click="handleClose">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import UploadFile from '@/components/uploadFile/Index.vue'
import { validateInteger } from '@/utils/validate'
function validateOvertimeHours(rule, value, callback) {
  if (!/^(?:[1-9]|1\d|2[0-3]|0?\.\d|\.[1-9])$/.test(value)) {
    return callback(new Error('请输入0.1到24的数字'))
  } else {
    return callback()
  }
}

// 一位小数
function oneDecimal(rule, value, callback) {
  const reg = /^([1-9][0-9]*|[0-9])(\.\d)?$/
  if (value && !reg.test(value)) {
    return callback(new Error('请输入一位以内的小数'))
  } else {
    return callback()
  }
}
export default {
  name: 'ExtraworkListAdd',
  components: { UploadFile },
  props: {
    id: {
      type: String,
      default: ''
    },
    addShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      validate_overtimeNum: (rule, value, callback) => {
        if (!/^[1-9]\d?$/g.test(value)) {
          return callback(new Error('请输入1-99数字'))
        } else {
          return callback()
        }
      },
      pickerOptions: {
        disabledDate(time) {
          const now = (new Date()).getTime()
          const sevenAfter = 91 * 24 * 3600 * 1000
          const res = now - sevenAfter
          return time.getTime() < res || time.getTime() > now
        }
      },

      title: '新增加班',
      dialogVisible: false,
      isEdit: false,
      info: {
        projectId: '', // 项目id
        overtimeType: '1', // 加班关联类型 1自建工人加班 2班组加班
        workers: [], // 工人
        teamId: '', // 班组id
        overtimeDate: '', // 加班日期
        overtimeNum: '', // 加班总人数
        overtimeHours: '', // 加班时长
        remark: '', // 加班原因
        fileList: [], // 附件列表
        laborPrice: '', // 加班单价
        laborAmount: '' // 费用总额
      },

      userList: [],
      teamData: [],
      submitShow: false,

      rules: {
        projectId: [
          { required: true, message: '请选择所属项目', trigger: 'change' }
        ],
        overtimeDate: [
          { required: true, message: '请选择加班日期', trigger: 'change' }
        ],
        workers: [
          { required: true, message: '请选择工人信息', trigger: 'change' }
        ],
        teamId: [
          { required: true, message: '请选择班组名称', trigger: 'change' }
        ],
        overtimeNum: [
          { required: true, message: '请输入加班人数', trigger: 'change' },
          { validator: validateInteger, trigger: ['blur', 'change'] }
        ],
        overtimeHours: [
          { required: true, message: '请输入加班时长', trigger: 'change' },
          { validator: validateOvertimeHours, trigger: ['blur', 'change'] },
          { validator: oneDecimal }
        ],
        remark: [
          { required: true, message: '请输入加班说明', trigger: 'change' }
        ],
        fileList: [
          { required: true, message: '请选择加班图片', trigger: 'change' }
        ],
        laborPrice: [
          { validator: validateInteger, trigger: ['blur', 'change'] }
        ],
        laborAmount: [
          { validator: validateInteger, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  filters: {
    imgListFormat(list) {
      const imgTypeList = ['jpeg', 'jpg', 'png']
      const imgList = []
      list.forEach((item) => {
        const str = item.fileName.split('.')
        if (imgTypeList.find((items) => items === str[str.length - 1].toLowerCase())) {
          imgList.push(item.filePrefix + item.fileUrl)
        }
      })
      return imgList || []
    }
  },
  computed: {
    normalProjectList() {
      return this.$store.state.projectList
    }
  },

  watch: {
    'info.projectId'(val) {
      if (val) {
        this.getUserList(this.info.projectId)
        this.getTeamList(this.info.projectId)
      }
    },
    addShow(val) {
      this.dialogVisible = val
    },
    id(val) {
      if (val) {
        this.getDetail()
        this.isEdit = true
        this.title = '编辑加班'
      } else {
        this.isEdit = false
        this.title = '新增加班'
      }
    }
  },

  created() {
    // this.getTeamList() // 加载班组列表
  },
  methods: {
    getTeamList(id) {
      this.$axios.get(this.$apis.laborManage.selectYhTeamByPage, {
        projectId: id
      }).then(res => {
        // console.log('班组', res)
        res.list = res.list.filter((item) => {
          return item.status === '1'
        })
        this.teamData = res.list || []
      })
    },

    // 项目人员列表
    getUserList(id) {
      this.$axios.get(this.$apis.worker.selectYhWorkerByPage, {
        projectId: id
      }).then(res => {
        this.userList = res.list || []
      })
    },

    getDetail() {
      // console.log('111', this.id)
      this.$axios.get(this.$apis.laborManage.selectYhOvertimeRecordDetailByOvertimeId, { overtimeId: this.id }).then(reslult => {
        const res1 = this.$axios.get(this.$apis.worker.selectYhWorkerByPage, {
          projectId: reslult.projectId
        })
        const res2 = this.$axios.get(this.$apis.laborManage.selectYhTeamByPage, {
          projectId: reslult.projectId
        })
        Promise.all([res1, res2]).then((res) => {
          this.userList = res[0].list || []
          this.teamData = res[1].list || []
          if (reslult?.workers?.length) {
            reslult.workers = reslult.workers.map((item) => {
              return item.workerId
            })
          }
          // console.log('this.info', reslult)
          this.info = reslult
        })
      })
    },

    selectProject(val) {
      this.info.overtimeType = '1'
      this.info.workers = []
      this.info.teamId = ''
      this.info.overtimeDate = ''
      this.info.overtimeNum = ''
      this.info.overtimeHours = ''
      this.info.remark = ''
      this.info.fileList = []
    },

    selectOvertimeType(val) {
      // console.log('val', val)
      this.info.overtimeNum = ''
      if (val === '1') {
        this.info.teamId = ''
      } else {
        this.info.workers = []
      }
    },

    selectWorkers() {
      // console.log('info.workers', this.info.workers)
      this.info.overtimeNum = '' + this.info.workers.length
    },

    // 文件上传成功返回
    onSuccess(file) {
      this.info.fileList.push(file)
    },

    imgRemove(index) {
      this.info.fileList.splice(index, 1)
    },

    saveForm() {
      // 处理工人信息和班组,绕过校验
      if (this.info?.overtimeType === '1') {
        // console.log('选了工人')
        this.info.teamId = '$123'
      } else {
        this.info.workers = ['123']
      }
      this.$refs.info.validate(valid => {
        if (valid) {
          // 处理工人信息和班组数据,绕过校验后还原数据
          if (this.info?.overtimeType === '1') {
            this.info.teamId = ''
          } else {
            // console.log('工人')
            this.info.workers = []
          }

          const params = JSON.parse(JSON.stringify(this.info))
          // console.log('params', params)
          this.submitShow = true
          // 处理工人信息和班组数据
          if (params.overtimeType === '1') {
            delete params.teamId
            params.workers = params.workers.map((item) => {
              if (typeof item === 'string') {
                return {
                  workerId: item
                }
              } else {
                return {
                  workerId: item.workerId
                }
              }
            })
          } else {
            delete params.workers
          }

          if (this.id) {
            // 编辑
            this.$axios.post(this.$apis.laborManage.updateYhOvertime, params).then(() => {
              this.$message.success('保存成功')
              this.handleClose()
              this.$emit('success')
            }).finally(() => {
              this.submitShow = false
            })
          } else {
            // 新增
            this.$axios.post(this.$apis.laborManage.verifyYhOvertime, params).then((res) => {
              if (res.status === '1') {
                this.$confirm('该日期已有加班记录, 是否继续添加?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.$axios.post(this.$apis.laborManage.insertYhOvertime, params).then(() => {
                    this.$message.success('保存成功')
                    this.handleClose()
                    this.$emit('success')
                  }).finally(() => {
                    this.submitShow = false
                  })
                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消添加'
                  })
                })
              } else {
                this.$axios.post(this.$apis.laborManage.insertYhOvertime, params).then(() => {
                  this.$message.success('保存成功')
                  this.handleClose()
                  this.$emit('success')
                }).finally(() => {
                  this.submitShow = false
                })
              }
            }).finally(() => {
              this.submitShow = false
            })
          }
        } else {
          // 处理工人信息和班组数据,绕过校验后还原数据
          if (this.info?.overtimeType === '1') {
            this.info.teamId = ''
          } else {
            this.info.workers = []
          }
        }
      })
    },

    handleClose() {
      this.$emit('update:addShow', false)
      this.$emit('update:id', '')
      this.info = {
        projectId: '', // 项目id
        overtimeType: '1', // 加班关联类型 1自建工人加班 2班组加班
        workers: [], // 工人
        teamId: '', // 班组id
        overtimeDate: '', // 加班日期
        overtimeNum: '', // 加班总人数
        overtimeHours: '', // 加班时长
        remark: '', // 加班原因
        fileList: [] // 附件列表
      }
      this.userList = []
      this.teamData = []
      this.$refs.info.resetFields()
    }
  }

}
</script>

<style scoped lang="scss">
@import "@/assets/scss/color";

.global-form2 .el-textarea {
  width: 380px;
}

.imgList {
  width: 100%;
  min-height: 104px;
  display: flex;
  margin-top: 15px;
  flex-wrap: wrap;

  .imgListTitle {
    margin-right: 10px;
  }

  .imgBlock {
    position: relative;
    height: 104px;
    width: 104px;
    margin: 0 10px 10px 0 !important;

    .el-image,
    img,
    video {
      width: 100%;
      height: 100%;
    }

    span {
      position: absolute;
      top: 0;
      right: 0;
      width: 0px;
      height: 0px;
      border-top: 34px solid $color-default;
      border-left: 34px solid transparent;
    }

    i {
      transition: all 0.3s;
      position: absolute;
      top: 3px;
      right: 3px;
      font-size: 15px;
      color: #ffffff;
      cursor: pointer;
    }

    i:hover {
      color: #ffffff98;
    }
  }

  ::v-deep .el-upload--picture-card {
    width: 104px;
    height: 104px;
    line-height: 26px;
    padding: 25px 10px;

    i {
      font-size: 22px;
      color: #999;
      margin-bottom: 7px;
    }
  }

  ::v-deep .el-upload {
    display: flex;
    flex-direction: column;
    justify-content: center !important;
    align-items: center !important;
  }
}
</style>
